import { render, staticRenderFns } from "./MenuTopHeader.vue?vue&type=template&id=2ca4b60d"
import script from "./MenuTopHeader.vue?vue&type=script&lang=js"
export * from "./MenuTopHeader.vue?vue&type=script&lang=js"
import style0 from "./MenuTopHeader.vue?vue&type=style&index=0&id=2ca4b60d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports